export const timeZoneCoordinatesMap = {
  'Europe/Andorra': { lat: 42.5063, lng: 1.5218 },
  'Asia/Dubai': { lat: 25.276987, lng: 55.296249 },
  'Asia/Kabul': { lat: 34.5553, lng: 69.2075 },
  'Europe/Tirane': { lat: 41.3275, lng: 19.8189 },
  'Asia/Yerevan': { lat: 40.1792, lng: 44.4991 },
  'Antarctica/Casey': { lat: -66.2818, lng: 110.5277 },
  'Antarctica/Davis': { lat: -68.5766, lng: 77.9674 },
  'Antarctica/Mawson': { lat: -67.6027, lng: 62.8738 },
  'Antarctica/Palmer': { lat: -64.7741, lng: -64.0539 },
  'Antarctica/Rothera': { lat: -67.5683, lng: -68.1253 },
  'Antarctica/Troll': { lat: -72.014, lng: 2.5352 },
  'America/Argentina/Buenos_Aires': { lat: -34.6132, lng: -58.3772 },
  'America/Argentina/Cordoba': { lat: -31.4201, lng: -64.1888 },
  'America/Argentina/Salta': { lat: -24.7821, lng: -65.4232 },
  'America/Argentina/Jujuy': { lat: -24.1858, lng: -65.2995 },
  'America/Argentina/Tucuman': { lat: -26.8083, lng: -65.2176 },
  'America/Argentina/Catamarca': { lat: -28.4696, lng: -65.7852 },
  'America/Argentina/La_Rioja': { lat: -29.4111, lng: -66.8507 },
  'America/Argentina/San_Juan': { lat: -31.5375, lng: -68.5364 },
  'America/Argentina/Mendoza': { lat: -32.8895, lng: -68.8458 },
  'America/Argentina/San_Luis': { lat: -33.295, lng: -66.3356 },
  'America/Argentina/Rio_Gallegos': { lat: -51.6226, lng: -69.2181 },
  'America/Argentina/Ushuaia': { lat: -54.8019, lng: -68.3029 },
  'Pacific/Pago_Pago': { lat: -14.2756, lng: -170.702 },
  'Europe/Vienna': { lat: 48.2082, lng: 16.3738 },
  'Australia/Lord_Howe': { lat: -31.558, lng: 159.083 },
  'Antarctica/Macquarie': { lat: -54.6167, lng: 158.85 },
  'Australia/Hobart': { lat: -42.8821, lng: 147.3272 },
  'Australia/Melbourne': { lat: -37.8136, lng: 144.9631 },
  'Australia/Sydney': { lat: -33.8688, lng: 151.2093 },
  'Australia/Broken_Hill': { lat: -31.9535, lng: 141.4534 },
  'Australia/Brisbane': { lat: -27.4698, lng: 153.0251 },
  'Australia/Lindeman': { lat: -20.4502, lng: 149.0426 },
  'Australia/Adelaide': { lat: -34.9285, lng: 138.6007 },
  'Australia/Darwin': { lat: -12.4634, lng: 130.8456 },
  'Australia/Perth': { lat: -31.9505, lng: 115.8605 },
  'Australia/Eucla': { lat: -31.6756, lng: 128.8891 },
  'Asia/Baku': { lat: 40.4093, lng: 49.8671 },
  'America/Barbados': { lat: 13.1939, lng: -59.5432 },
  'Asia/Dhaka': { lat: 23.8103, lng: 90.4125 },
  'Europe/Brussels': { lat: 50.8503, lng: 4.3517 },
  'Europe/Sofia': { lat: 42.6975, lng: 23.3242 },
  'Atlantic/Bermuda': { lat: 32.3078, lng: -64.7505 },
  'America/La_Paz': { lat: -16.5, lng: -68.15 },
  'America/Noronha': { lat: -3.8551, lng: -32.4231 },
  'America/Belem': { lat: -1.4558, lng: -48.4902 },
  'America/Fortaleza': { lat: -3.7172, lng: -38.5434 },
  'America/Recife': { lat: -8.0476, lng: -34.877 },
  'America/Araguaina': { lat: -7.1924, lng: -48.2044 },
  'America/Maceio': { lat: -9.6658, lng: -35.735 },
  'America/Bahia': { lat: -12.9714, lng: -38.5014 },
  'America/Sao_Paulo': { lat: -23.5505, lng: -46.6333 },
  'America/Campo_Grande': { lat: -20.4697, lng: -54.6201 },
  'America/Cuiaba': { lat: -15.6014, lng: -56.0979 },
  'America/Santarem': { lat: -2.4385, lng: -54.6996 },
  'America/Porto_Velho': { lat: -8.7612, lng: -63.9004 },
  'America/Boa_Vista': { lat: 2.8235, lng: -60.6758 },
  'America/Manaus': { lat: -3.119, lng: -60.0217 },
  'America/Eirunepe': { lat: -6.6617, lng: -69.8737 },
  'America/Rio_Branco': { lat: -9.9747, lng: -67.8243 },
  'Asia/Thimphu': { lat: 27.4712, lng: 89.6339 },
  'Europe/Minsk': { lat: 53.9006, lng: 27.559 },
  'America/Belize': { lat: 17.1899, lng: -88.4976 },
  'America/St_Johns': { lat: 47.5615, lng: -52.7126 },
  'America/Halifax': { lat: 44.6488, lng: -63.5752 },
  'America/Glace_Bay': { lat: 46.1969, lng: -59.9565 },
  'America/Moncton': { lat: 46.0878, lng: -64.7782 },
  'America/Goose_Bay': { lat: 53.301, lng: -60.3267 },
  'America/Toronto': { lat: 43.6511, lng: -79.347 },
  'America/Iqaluit': { lat: 63.7467, lng: -68.5169 },
  'America/Winnipeg': { lat: 49.8951, lng: -97.1384 },
  'America/Resolute': { lat: 74.6973, lng: -94.8293 },
  'America/Rankin_Inlet': { lat: 62.808, lng: -92.08 },
  'America/Regina': { lat: 50.4452, lng: -104.6189 },
  'America/Swift_Current': { lat: 50.2887, lng: -107.7936 },
  'America/Edmonton': { lat: 53.5461, lng: -113.4938 },
  'America/Cambridge_Bay': { lat: 69.1177, lng: -105.0583 },
  'America/Yellowknife': { lat: 62.454, lng: -114.3726 },
  'America/Inuvik': { lat: 68.3606, lng: -133.7218 },
  'America/Dawson_Creek': { lat: 55.7596, lng: -120.2372 },
  'America/Fort_Nelson': { lat: 58.8053, lng: -122.7002 },
  'America/Whitehorse': { lat: 60.7212, lng: -135.0568 },
  'America/Dawson': { lat: 64.0601, lng: -139.4333 },
  'America/Vancouver': { lat: 49.2827, lng: -123.1207 },
  'Europe/Zurich': { lat: 47.3769, lng: 8.5417 },
  'Africa/Abidjan': { lat: 5.3453, lng: -4.0244 },
  'Pacific/Rarotonga': { lat: -21.2292, lng: -159.7761 },
  'America/Santiago': { lat: -33.4489, lng: -70.6693 },
  'America/Punta_Arenas': { lat: -53.1548, lng: -70.9113 },
  'Pacific/Easter': { lat: -27.1127, lng: -109.3497 },
  'Asia/Shanghai': { lat: 31.2304, lng: 121.4737 },
  'Asia/Urumqi': { lat: 43.8256, lng: 87.6168 },
  'America/Bogota': { lat: 4.711, lng: -74.0721 },
  'America/Costa_Rica': { lat: 9.7489, lng: -83.7534 },
  'America/Havana': { lat: 23.1136, lng: -82.3666 },
  'Atlantic/Cape_Verde': { lat: 14.933, lng: -23.5133 },
  'Asia/Nicosia': { lat: 35.1856, lng: 33.3823 },
  'Asia/Famagusta': { lat: 35.1142, lng: 33.9523 },
  'Europe/Prague': { lat: 50.0755, lng: 14.4378 },
  'Europe/Berlin': { lat: 52.52, lng: 13.405 },
  'America/Santo_Domingo': { lat: 18.4861, lng: -69.9312 },
  'Africa/Algiers': { lat: 36.7538, lng: 3.0588 },
  'America/Guayaquil': { lat: -2.1709, lng: -79.9224 },
  'Pacific/Galapagos': { lat: -0.9538, lng: -89.6206 },
  'Europe/Tallinn': { lat: 59.437, lng: 24.7536 },
  'Africa/Cairo': { lat: 30.0444, lng: 31.2357 },
  'Africa/El_Aaiun': { lat: 27.15, lng: -13.2 },
  'Europe/Madrid': { lat: 40.4168, lng: -3.7038 },
  'Africa/Ceuta': { lat: 35.8894, lng: -5.316 },
  'Atlantic/Canary': { lat: 28.2916, lng: -16.6291 },
  'Europe/Helsinki': { lat: 60.1695, lng: 24.9354 },
  'Pacific/Fiji': { lat: -17.7134, lng: 178.065 },
  'Atlantic/Stanley': { lat: -51.6977, lng: -57.8517 },
  'Pacific/Kosrae': { lat: 5.3167, lng: 162.9833 },
  'Atlantic/Faroe': { lat: 61.8926, lng: -6.9118 },
  'Europe/Paris': { lat: 48.8566, lng: 2.3522 },
  'Europe/London': { lat: 51.5074, lng: -0.1278 },
  'Asia/Tbilisi': { lat: 41.7151, lng: 44.8271 },
  'America/Cayenne': { lat: 4.9224, lng: -52.3135 },
  'Europe/Gibraltar': { lat: 36.1408, lng: -5.3536 },
  'America/Nuuk': { lat: 64.1835, lng: -51.7216 },
  'America/Danmarkshavn': { lat: 76.7693, lng: -18.6693 },
  'America/Scoresbysund': { lat: 70.4841, lng: -21.9641 },
  'America/Thule': { lat: 76.5312, lng: -68.7031 },
  'Europe/Athens': { lat: 37.9838, lng: 23.7275 },
  'Atlantic/South_Georgia': { lat: -54.4296, lng: -36.5879 },
  'America/Guatemala': { lat: 14.6349, lng: -90.5069 },
  'Pacific/Guam': { lat: 13.4443, lng: 144.7937 },
  'Africa/Bissau': { lat: 11.8817, lng: -15.617 },
  'America/Guyana': { lat: 6.8013, lng: -58.1551 },
  'Asia/Hong_Kong': { lat: 22.3193, lng: 114.1694 },
  'America/Tegucigalpa': { lat: 14.0723, lng: -87.1921 },
  'America/Port-au-Prince': { lat: 18.5944, lng: -72.3074 },
  'Europe/Budapest': { lat: 47.4979, lng: 19.0402 },
  'Asia/Jakarta': { lat: -6.2088, lng: 106.8456 },
  'Asia/Pontianak': { lat: -0.0263, lng: 109.3425 },
  'Asia/Makassar': { lat: -5.1477, lng: 119.4327 },
  'Asia/Jayapura': { lat: -2.5337, lng: 140.7181 },
  'Europe/Dublin': { lat: 53.3498, lng: -6.2603 },
  'Asia/Jerusalem': { lat: 31.7683, lng: 35.2137 },
  'Asia/Calcutta': { lat: 22.5726, lng: 88.3639 },
  'Indian/Chagos': { lat: -6.343, lng: 71.8765 },
  'Asia/Baghdad': { lat: 33.3152, lng: 44.3661 },
  'Asia/Tehran': { lat: 35.6892, lng: 51.389 },
  'Europe/Rome': { lat: 41.9028, lng: 12.4964 },
  'America/Jamaica': { lat: 18.1096, lng: -77.2975 },
  'Asia/Amman': { lat: 31.9539, lng: 35.9106 },
  'Asia/Tokyo': { lat: 35.6762, lng: 139.6503 },
  'Africa/Nairobi': { lat: -1.2864, lng: 36.8172 },
  'Asia/Bishkek': { lat: 42.8746, lng: 74.5698 },
  'Pacific/Tarawa': { lat: 1.4518, lng: 172.9717 },
  'Pacific/Kanton': { lat: -2.7697, lng: -171.7182 },
  'Pacific/Kiritimati': { lat: 1.8709, lng: -157.3631 },
  'Asia/Pyongyang': { lat: 39.0392, lng: 125.7625 },
  'Asia/Seoul': { lat: 37.5665, lng: 126.978 },
  'Asia/Almaty': { lat: 43.2389, lng: 76.8897 },
  'Asia/Qyzylorda': { lat: 44.8527, lng: 65.5095 },
  'Asia/Qostanay': { lat: 53.2192, lng: 63.6345 },
  'Asia/Aqtobe': { lat: 50.2839, lng: 57.167 },
  'Asia/Aqtau': { lat: 43.6382, lng: 51.1985 },
  'Asia/Atyrau': { lat: 47.0945, lng: 51.9235 },
  'Asia/Oral': { lat: 51.233, lng: 51.366 },
  'Asia/Beirut': { lat: 33.8886, lng: 35.4955 },
  'Asia/Colombo': { lat: 6.9271, lng: 79.8612 },
  'Africa/Monrovia': { lat: 6.3, lng: -10.7973 },
  'Europe/Vilnius': { lat: 54.6872, lng: 25.2797 },
  'Europe/Riga': { lat: 56.9496, lng: 24.1052 },
  'Africa/Tripoli': { lat: 32.8872, lng: 13.1913 },
  'Africa/Casablanca': { lat: 33.5731, lng: -7.5898 },
  'Europe/Chisinau': { lat: 47.0105, lng: 28.8638 },
  'Pacific/Kwajalein': { lat: 9.1082, lng: 167.3334 },
  'Asia/Yangon': { lat: 16.8409, lng: 96.1735 },
  'Asia/Ulaanbaatar': { lat: 47.8864, lng: 106.9057 },
  'Asia/Hovd': { lat: 48.0056, lng: 91.64 },
  'Asia/Choibalsan': { lat: 48.0769, lng: 114.5352 },
  'Asia/Macau': { lat: 22.1987, lng: 113.5439 },
  'America/Martinique': { lat: 14.6415, lng: -61.0242 },
  'Europe/Malta': { lat: 35.9375, lng: 14.3754 },
  'Indian/Mauritius': { lat: -20.3484, lng: 57.5522 },
  'Indian/Maldives': { lat: 3.2028, lng: 73.2207 },
  'America/Mexico_City': { lat: 19.4326, lng: -99.1332 },
  'America/Cancun': { lat: 21.1619, lng: -86.8515 },
  'America/Merida': { lat: 20.9674, lng: -89.5926 },
  'America/Monterrey': { lat: 25.6866, lng: -100.3161 },
  'America/Matamoros': { lat: 25.8693, lng: -97.5027 },
  'America/Chihuahua': { lat: 28.632, lng: -106.0691 },
  'America/Ciudad_Juarez': { lat: 31.6927, lng: -106.4246 },
  'America/Ojinaga': { lat: 29.5642, lng: -104.4106 },
  'America/Mazatlan': { lat: 23.2494, lng: -106.4111 },
  'America/Bahia_Banderas': { lat: 20.6871, lng: -105.3056 },
  'America/Hermosillo': { lat: 29.072967, lng: -110.955919 },
  'America/Tijuana': { lat: 32.5149, lng: -117.0382 },
  'Asia/Kuching': { lat: 1.559, lng: 110.344 },
  'Africa/Maputo': { lat: -25.9692, lng: 32.5732 },
  'Africa/Windhoek': { lat: -22.5597, lng: 17.0832 },
  'Pacific/Noumea': { lat: -22.276, lng: 166.457 },
  'Pacific/Norfolk': { lat: -29.033, lng: 167.955 },
  'Africa/Lagos': { lat: 6.5244, lng: 3.3792 },
  'America/Managua': { lat: 12.115, lng: -86.2362 },
  'Asia/Kathmandu': { lat: 27.7172, lng: 85.324 },
  'Pacific/Nauru': { lat: -0.5271, lng: 166.936 },
  'Pacific/Niue': { lat: -19.0544, lng: -169.8672 },
  'Pacific/Auckland': { lat: -36.8485, lng: 174.7633 },
  'Pacific/Chatham': { lat: -43.9555, lng: -176.5597 },
  'America/Panama': { lat: 8.9833, lng: -79.5167 },
  'America/Lima': { lat: -12.0464, lng: -77.0428 },
  'Pacific/Tahiti': { lat: -17.6509, lng: -149.426 },
  'Pacific/Marquesas': { lat: -9.7353, lng: -139.0223 },
  'Pacific/Gambier': { lat: -23.1326, lng: -134.9719 },
  'Pacific/Port_Moresby': { lat: -9.478, lng: 147.15 },
  'Pacific/Bougainville': { lat: -6.2263, lng: 155.566 },
  'Asia/Manila': { lat: 14.5995, lng: 120.9842 },
  'Asia/Karachi': { lat: 24.8607, lng: 67.0011 },
  'Europe/Warsaw': { lat: 52.2297, lng: 21.0122 },
  'America/Miquelon': { lat: 47.0228, lng: -56.3814 },
  'Pacific/Pitcairn': { lat: -25.066, lng: -130.101 },
  'America/Puerto_Rico': { lat: 18.2208, lng: -66.5901 },
  'Asia/Gaza': { lat: 31.5017, lng: 34.4668 },
  'Asia/Hebron': { lat: 31.5326, lng: 35.0998 },
  'Europe/Lisbon': { lat: 38.7223, lng: -9.1393 },
  'Atlantic/Madeira': { lat: 32.7607, lng: -16.9595 },
  'Atlantic/Azores': { lat: 37.7412, lng: -25.6756 },
  'Pacific/Palau': { lat: 7.5149, lng: 134.5825 },
  'America/Asuncion': { lat: -25.2637, lng: -57.5759 },
  'Asia/Qatar': { lat: 25.3548, lng: 51.1839 },
  'Europe/Bucharest': { lat: 44.4268, lng: 26.1025 },
  'Europe/Belgrade': { lat: 44.7866, lng: 20.4489 },
  'Europe/Kaliningrad': { lat: 54.7104, lng: 20.4522 },
  'Europe/Moscow': { lat: 55.7558, lng: 37.6173 },
  'Europe/Simferopol': { lat: 44.9521, lng: 34.1024 },
  'Europe/Kirov': { lat: 58.6035, lng: 49.6679 },
  'Europe/Volgograd': { lat: 48.708, lng: 44.5133 },
  'Europe/Astrakhan': { lat: 46.3497, lng: 48.0408 },
  'Europe/Saratov': { lat: 51.5315, lng: 46.0379 },
  'Europe/Ulyanovsk': { lat: 54.3197, lng: 48.3996 },
  'Europe/Samara': { lat: 53.2415, lng: 50.2212 },
  'Asia/Yekaterinburg': { lat: 56.8389, lng: 60.6057 },
  'Asia/Omsk': { lat: 54.9914, lng: 73.3645 },
  'Asia/Novosibirsk': { lat: 55.0084, lng: 82.9357 },
  'Asia/Barnaul': { lat: 53.3548, lng: 83.7699 },
  'Asia/Tomsk': { lat: 56.4847, lng: 84.9482 },
  'Asia/Novokuznetsk': { lat: 53.7557, lng: 87.1099 },
  'Asia/Krasnoyarsk': { lat: 56.0153, lng: 92.8932 },
  'Asia/Irkutsk': { lat: 52.2869, lng: 104.305 },
  'Asia/Chita': { lat: 52.0317, lng: 113.5009 },
  'Asia/Yakutsk': { lat: 62.0281, lng: 129.7326 },
  'Asia/Khandyga': { lat: 62.6667, lng: 135.6 },
  'Asia/Vladivostok': { lat: 43.1155, lng: 131.8855 },
  'Asia/Ust-Nera': { lat: 64.5667, lng: 143.2 },
  'Asia/Magadan': { lat: 59.568, lng: 150.8035 },
  'Asia/Sakhalin': { lat: 47.708, lng: 142.2057 },
  'Asia/Srednekolymsk': { lat: 67.4503, lng: 153.71 },
  'Asia/Kamchatka': { lat: 53.0537, lng: 158.6559 },
  'Asia/Anadyr': { lat: 64.7335, lng: 177.5089 },
  'Asia/Riyadh': { lat: 24.7136, lng: 46.6753 },
  'Pacific/Guadalcanal': { lat: -9.74, lng: 160.054 },
  'Africa/Khartoum': { lat: 15.5007, lng: 32.5599 },
  'Asia/Singapore': { lat: 1.3521, lng: 103.8198 },
  'America/Paramaribo': { lat: 5.852, lng: -55.2038 },
  'Africa/Juba': { lat: 4.8594, lng: 31.5713 },
  'Africa/Sao_Tome': { lat: 0.3365, lng: 6.7273 },
  'America/El_Salvador': { lat: 13.7942, lng: -88.8965 },
  'Asia/Damascus': { lat: 33.5138, lng: 36.2765 },
  'America/Grand_Turk': { lat: 21.4612, lng: -71.1419 },
  'Africa/Ndjamena': { lat: 12.1348, lng: 15.0557 },
  'Asia/Bangkok': { lat: 13.7563, lng: 100.5018 },
  'Asia/Dushanbe': { lat: 38.5733, lng: 68.7864 },
  'Pacific/Fakaofo': { lat: -9.38, lng: -171.23 },
  'Asia/Dili': { lat: -8.5569, lng: 125.5603 },
  'Asia/Ashgabat': { lat: 37.9601, lng: 58.3261 },
  'Africa/Tunis': { lat: 36.8065, lng: 10.1815 },
  'Pacific/Tongatapu': { lat: -21.1394, lng: -175.204 },
  'Europe/Istanbul': { lat: 41.0082, lng: 28.9784 },
  'Asia/Taipei': { lat: 25.033, lng: 121.5654 },
  'Europe/Kyiv': { lat: 50.4501, lng: 30.5234 },
  'America/New_York': { lat: 40.7128, lng: -74.006 },
  'America/Detroit': { lat: 42.3314, lng: -83.0458 },
  'America/Kentucky/Louisville': { lat: 38.2527, lng: -85.7585 },
  'America/Kentucky/Monticello': { lat: 36.8292, lng: -84.8491 },
  'America/Indiana/Indianapolis': { lat: 39.7684, lng: -86.1581 },
  'America/Indiana/Vincennes': { lat: 38.6773, lng: -87.5286 },
  'America/Indiana/Winamac': { lat: 41.0514, lng: -86.6039 },
  'America/Indiana/Marengo': { lat: 38.3753, lng: -86.3436 },
  'America/Indiana/Petersburg': { lat: 38.4917, lng: -87.2789 },
  'America/Indiana/Vevay': { lat: 38.7473, lng: -85.0675 },
  'America/Chicago': { lat: 41.8781, lng: -87.6298 },
  'America/Indiana/Tell_City': { lat: 37.9514, lng: -86.7678 },
  'America/Indiana/Knox': { lat: 41.2956, lng: -86.625 },
  'America/Menominee': { lat: 45.1077, lng: -87.6146 },
  'America/North_Dakota/Center': { lat: 47.1164, lng: -101.2979 },
  'America/North_Dakota/New_Salem': { lat: 46.8447, lng: -101.4138 },
  'America/North_Dakota/Beulah': { lat: 47.2639, lng: -101.7774 },
  'America/Denver': { lat: 39.7392, lng: -104.9903 },
  'America/Boise': { lat: 43.615, lng: -116.2023 },
  'America/Phoenix': { lat: 33.4484, lng: -112.074 },
  'America/Los_Angeles': { lat: 34.0522, lng: -118.2437 },
  'America/Anchorage': { lat: 61.2181, lng: -149.9003 },
  'America/Juneau': { lat: 58.3019, lng: -134.4197 },
  'America/Sitka': { lat: 57.0531, lng: -135.33 },
  'America/Metlakatla': { lat: 55.1297, lng: -131.5746 },
  'America/Yakutat': { lat: 59.5469, lng: -139.7273 },
  'America/Nome': { lat: 64.5011, lng: -165.4064 },
  'America/Adak': { lat: 51.8797, lng: -176.6581 },
  'Pacific/Honolulu': { lat: 21.3069, lng: -157.8583 },
  'America/Montevideo': { lat: -34.9011, lng: -56.1645 },
  'Asia/Samarkand': { lat: 39.627, lng: 66.974 },
  'Asia/Tashkent': { lat: 41.2995, lng: 69.2401 },
  'America/Caracas': { lat: 10.4806, lng: -66.9036 },
  'Asia/Ho_Chi_Minh': { lat: 10.8231, lng: 106.6297 },
  'Pacific/Efate': { lat: -17.7392, lng: 168.321 },
  'Pacific/Apia': { lat: -13.8333, lng: -171.7667 },
  'Africa/Johannesburg': { lat: -26.2041, lng: 28.0473 },
};
